import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    leftBarStatus : true,
};

const leftBarSlice = createSlice({
  name: "Job Position Store",
  initialState: initialState,
  reducers: {
    setLeftBar(state, action) {
        state.leftBarStatus = action.payload;
    }
  },
 
});

export const leftBarActions = leftBarSlice.actions;

export default leftBarSlice.reducer;
